import {GitHubAvatar} from '@github-ui/github-avatar'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {clsx} from 'clsx'
import {StatusIcon} from './StatusIcon'
import styles from './StatusAvatar.module.css'

export type StatusAvatarProps = {
  altText: string
  hovercardUrl?: string
  src: string
  square: boolean
  icon: React.ElementType
  iconColor: string
  backgroundColor?: string
  backgroundClassName?: string
  className?: string
  size?: 18 | 20 | 24
}
/**
 * This component renders an avatar (either square or round) with a related status emoji in the bottom right corner
 */
export function StatusAvatar({
  altText,
  hovercardUrl,
  src,
  square,
  icon,
  iconColor,
  backgroundColor,
  backgroundClassName,
  className,
  size = 20,
}: StatusAvatarProps) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  return (
    <div
      className={clsx(styles.StatusAvatar, className)}
      {...(hovercardUrl ? getHovercardAttributesForType('user', {url: hovercardUrl}) : {})}
    >
      <GitHubAvatar alt={altText} size={size} square={square} src={src} />
      <StatusIcon
        icon={icon}
        iconColor={iconColor}
        size={12}
        backgroundColor={backgroundColor}
        backgroundClassName={backgroundClassName}
      />
    </div>
  )
}
